var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4766 15.0675V6.93221C19.4766 6.81047 19.4442 6.6909 19.3828 6.58574C19.3214 6.48059 19.2331 6.39361 19.127 6.3337L11.8993 2.25354C11.7959 2.19521 11.6793 2.16455 11.5606 2.16455C11.4419 2.16455 11.3252 2.19521 11.2219 2.25354L3.99417 6.3337C3.88805 6.39361 3.79976 6.48059 3.73833 6.58574C3.6769 6.6909 3.64453 6.81047 3.64453 6.93221V15.0675C3.64453 15.1892 3.6769 15.3088 3.73833 15.4139C3.79976 15.5191 3.88805 15.6061 3.99417 15.666L11.2219 19.7461C11.3252 19.8045 11.4419 19.8351 11.5606 19.8351C11.6793 19.8351 11.7959 19.8045 11.8993 19.7461L19.127 15.666C19.2331 15.6061 19.3214 15.5191 19.3828 15.4139C19.4442 15.3088 19.4766 15.1892 19.4766 15.0675V15.0675Z",
    stroke: "#09abf1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5624 14.0938C13.2732 14.0938 14.66 12.7086 14.66 11C14.66 9.29137 13.2732 7.90625 11.5624 7.90625C9.85168 7.90625 8.46484 9.29137 8.46484 11C8.46484 12.7086 9.85168 14.0938 11.5624 14.0938Z",
    stroke: "#09abf1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.802fd77b773514493059544a0f17a151.svg";
export { ForwardRef as ReactComponent };